export default function SimplePage({ title, children }) {
  return (
    <div className="pt-12 pb-24">
      <div className="container-eq max-w-3xl">
        <h1 className="text-4xl sm:text-5xl font-display font-black tracking-tighter" data-testid="simple-page-title">{title}</h1>
        <div className="mt-8 text-neutral-700 leading-relaxed space-y-4">{children}</div>
      </div>
    </div>
  );
}

export function PrivacyPage() {
  return (
    <SimplePage title="Privacy Policy">
      <p>EQtech Academy respects your privacy. This policy outlines how we collect, use, and protect your personal information.</p>
      <p><strong>Information we collect:</strong> name, email, phone, city, course preferences submitted via forms or the chatbot.</p>
      <p><strong>How we use it:</strong> to respond to enquiries, share course details, and provide career counseling. We never sell your data.</p>
      <p><strong>Security:</strong> data is stored securely and access is restricted to authorized administrators.</p>
      <p>For queries about your data, email us at info@eqtech.academy.</p>
    </SimplePage>
  );
}

export function TermsPage() {
  return (
    <SimplePage title="Terms & Conditions">
      <p>By using this website you agree to the following terms:</p>
      <p><strong>Course enrollment:</strong> Fees, curriculum and schedule are subject to change. Refunds are processed as per the enrollment agreement.</p>
      <p><strong>Content:</strong> All content, including course materials, is copyright EQtech Academy. Redistribution is prohibited.</p>
      <p><strong>Use of website:</strong> You agree not to misuse the site, attempt unauthorized access, or upload harmful content.</p>
      <p>Contact info@eqtech.academy for any clarification.</p>
    </SimplePage>
  );
}
